module.exports = __webpack_public_path__ + "img/03.adbdc069.jpg";